import { useEffect, useMemo } from "react";
import TableNew, { CELL_TYPES } from "../../../shared/Table";
import { TableCellAccountRedirect } from "../../../shared/Table/components/Cell";
import TableCellLoanActions from "./TableCellLoanActions";
import LoanDetails from "./LoanDetails/LoanDetails.Component";

import RefreshButton from "../../../shared/ui/Refresh.Button";
import LoanTableButtons from "./LoanTableButtons";

import { loanStages } from "../../../shared/dictionary/enums";
import PropTypes from "prop-types";
import ClaimsWrapper from "../../../shared/ui/Claim.Wrapper";
import { compose } from "redux";
import loanConnector from "../../../services/loan/connector";
import accountInfosConnector from "../../../services/users/accountInfo/connector";
import { usersConnector } from "../../../services/users/connectors/usersConnector";
import userLoanConnector from "../../../services/loan/user.connector";
import { allClaimsOtherThanAml } from "../../../shared/ClaimLists/Claim.Aml.All.List";

const LoansComponentInternal = (props) => {
  const columns = useMemo(() => {
    return [
      {
        key: "BorrowerId",
        label: "Get ssn",
        filter: false,
        visible: true,
        type: CELL_TYPES.ssn,
      },
      {
        key: "DisputedSince",
        label: "Disputed since",
        visible: true,
        type: CELL_TYPES.text,
      },
      {
        key: "CreditStage",
        label: "Loan stage",
        visible: true,
        enumDict: loanStages,
        type: CELL_TYPES.enum,
      },
      {
        key: "PaidOut",
        label: "Paid Out ",
        visible: true,
        type: CELL_TYPES.date,
      },
      {
        key: "Amount.Amount",
        label: "Amount ",
        visible: true,
        type: CELL_TYPES.money,
      },
      {
        key: "PayoutAmount.Amount",
        label: "Payout Amount ",
        visible: true,
        type: CELL_TYPES.money,
      },
      {
        key: "InitFee.Amount",
        label: "Init Fee ",
        visible: false,
        type: CELL_TYPES.money,
      },
      {
        key: "IsUpSwitch",
        label: "Is Replacement ",
        visible: true,
        type: CELL_TYPES.custom,
        renderer: (value) => (value ? "Yes" : "No"),
      },
      { key: "OCR", label: "OCR ", visible: true, type: CELL_TYPES.text },
      {
        key: "LoanTerm",
        label: "LoanTerm ",
        visible: true,
        type: CELL_TYPES.number,
      },
      {
        key: "Term",
        label: "Original Term",
        visible: true,
        type: CELL_TYPES.number,
      },
      {
        key: "NominalInterest.Value",
        label: "Interest",
        visible: true,
        type: CELL_TYPES.percentage,
      },
      {
        key: "IntermediationFee.Amount",
        label: "Intermediation Fee",
        visible: true,
        type: CELL_TYPES.money,
      },
      {
        key: "TotalPaid.Amount",
        label: "Paid amount",
        visible: true,
        type: CELL_TYPES.money,
      },
      {
        key: "AccountId",
        label: "Account Id",
        visible: false,
        type: CELL_TYPES.text,
        renderer: (value) => {
          return <TableCellAccountRedirect value={value} type={"accountId"} />;
        },
      },
      {
        key: "actions",
        label: "Actions",
        visible: true,
        filter: false,
        renderer: (value, item) => {
          return (
            <ClaimsWrapper claimAuth={allClaimsOtherThanAml}>
              <TableCellLoanActions
                fullRepayment={props.fullRepayment}
                getFullRepayment={props.getFullRepayment}
                value={value}
                item={item}
              />
            </ClaimsWrapper>
          );
        },
      },
    ];
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    props.getLoans(props.accountId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.currentUser?.Ssn]);

  const refreshFunction = props.getLoans.bind(this, props.accountId);

  return (
    <div className="loans-layout body-height content-padding">
      <RefreshButton onRefreshClick={refreshFunction} />
      <h3>Loanstep: Loans</h3>
      {!props.loans.fetched ? (
        <div> Loading... </div>
      ) : (
        <div>
          <br />
          <TableNew
            {...props}
            columns={columns}
            items={props.loans.data}
            actionColumnWidth={200}
            showDetails={true}
            tableKey={"Loans-Main-" + !!props.accountId}
            selectId={"Id"}
            detailsRenderer={(item) => {
              return <LoanDetails {...props} item={item} />;
            }}
            aboveContentRenderer={(getSelected, rows) => {
              return (
                <LoanTableButtons
                  {...{ getSelected, rows, getLoans: props.getLoans }}
                />
              );
            }}
          />
        </div>
      )}
    </div>
  );
};

LoansComponentInternal.propTypes = {
  getLoans: PropTypes.func,
  changeLoanListPage: PropTypes.func,
  changeLoanListFilter: PropTypes.func,
  fullRepayment: PropTypes.func,
  getFullRepayment: PropTypes.func,
  updateLoans: PropTypes.func,
  accountId: PropTypes.string,
  loans: PropTypes.object,
  currentUser: PropTypes.object,
};

export const LoansComponent = compose(
  loanConnector,
  accountInfosConnector,
)(LoansComponentInternal);
export const UserLoansComponent = compose(
  userLoanConnector,
  accountInfosConnector,
  usersConnector,
)(LoansComponentInternal);
